<div class="row" style="height: 100%">
	<div class="imgContainer col-md-{{smallWindow ? 12 : 8}}" #container>
		<button class="button component soundToggle" *ngIf="guiEnabled">
			<app-audio *ngIf="monument" [audioUrl]="globalDataService.getObjectTranslation(monument.monumentTranslations, 'audioPath')"></app-audio>
		</button>
		<ng-container *ngIf="view.images">
			<ngb-carousel *ngIf="slider" [showNavigationIndicators]="slider.length >1" [showNavigationArrows]="slider.length >1">
				<ng-template ngbSlide *ngFor="let slide of slider">
					<div class="picsum-img-wrapper">
						<img [src]="slide | secure | async">
					</div>
				</ng-template>
			</ngb-carousel>
		</ng-container>
		<ng-container *ngIf="view.panoramic">
			<app-panorama-container *ngIf="monument"
									[panoramic]="monument.panoramic"
									[haveLabels]="false"
									[showCompass]="false"
									[rotateX]="monument.panoramicOrientation"
									[enableCaching]="true"
									style="position: absolute;width: 97%; height: 100%;"></app-panorama-container>
		</ng-container>
		<ng-container *ngIf="view.threeD">
			<app-model-container [guiEnabled]="guiEnabled" [fbxScale]="monument.fbxScale" *ngIf="monument" [Monument3dModelPath]="monument.model" style="height: 100%; display:
			block;">
			</app-model-container>
		</ng-container>
		<ng-container *ngIf="info && smallWindow && monument">
			<div class="infoFloating">
				<div class="closeInfo" (click)="info = !info">
					<fa-icon [icon]="['fas','times']"></fa-icon>
				</div>
				<ng-container *ngTemplateOutlet="information"></ng-container>
			</div>
		</ng-container>
		<div class="components text-center" *ngIf="guiEnabled">
			<button class="button component" (click)="toggleView('images')" *ngIf="monument && monument.componentConfiguration.gallery">
				<fa-icon class="chevronDown" [icon]="['far','images']"></fa-icon>
			</button>
			<button class="button component" (click)="toggleView('threeD')" *ngIf="monument && monument.componentConfiguration.model">
				<img src="assets/images/remotes/bottom-3D-icon-blk.png" />
			</button>
			<button class="button component" (click)="toggleView('panoramic')" *ngIf="monument && monument.componentConfiguration.vr">
				<img src="assets/images/remotes/bottom-panoramic-icon-blk.png" />
			</button>
			<button class="button component" (click)="info = !info" *ngIf="smallWindow" #smallInfo>
				<fa-icon class="chevronDown" style="pointer-events: none" [icon]="['fas','info-circle']"></fa-icon>
			</button>
		</div>
	</div>
	<div class="col-md-4" *ngIf="monument && !smallWindow">
		<ng-container *ngTemplateOutlet="information"></ng-container>
	</div>
</div>
<ng-template #information>
	<h2>
		{{this.globalDataService.getObjectTranslation(monument.monumentTranslations, "name")}}
	</h2>
	<div class="monumentShortDescription">
		{{this.globalDataService.getObjectTranslation(monument.monumentTranslations, "shortDescription")}}
	</div>
	<div class="monumentInfo" [class.fullHeight]="!monument.monumentTranslations[0]['extraDescription']"
		 [innerHTML]="this.globalDataService.getObjectTranslation(monument.monumentTranslations,
	'description')"></div>
	<div class="extraInfo row" *ngIf="monument.monumentTranslations[0]['extraDescription']">
		<div class="col-md-12 extraTitle">
			{{'TRANS_REMOTE.TRANS_EXTRA' | translate}}
		</div>
		<div class="col-md-4">
			<app-image-popup [imagesSrc]="monument.extraImage | secure | async"></app-image-popup>
		</div>
		<div class="col-md-8" style="padding: 0;">
			<span [innerHTML]="this.globalDataService.getObjectTranslation(monument.monumentTranslations,'extraDescription')"></span>
		</div>
	</div>
</ng-template>